const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const CONSENT_KEY = "rl_analytics_consent";

let gaLoaded = false;

function loadGoogleAnalytics() {
  if (gaLoaded || !MEASUREMENT_ID) return;
  gaLoaded = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag("js", new Date());
  // send_page_view is off here — App.js drives page_view itself on route
  // change, since GA4's own auto pageview can't see React Router navigation.
  gtag("config", MEASUREMENT_ID, { send_page_view: false });
}

// null = no decision yet (show the banner), "granted" | "denied" = decided.
export function getConsent() {
  return localStorage.getItem(CONSENT_KEY);
}

export function setConsent(value) {
  localStorage.setItem(CONSENT_KEY, value);
  if (value === "granted") loadGoogleAnalytics();
}

// Call once on app start so returning visitors who already said yes get
// tracked again without having to see the banner every visit.
export function resumeAnalyticsIfConsented() {
  if (getConsent() === "granted") loadGoogleAnalytics();
}

export function trackPageview(path) {
  if (getConsent() !== "granted" || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
